var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('horizontal-navbar'),_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('mainPage.title')))]),_c('hr'),_c('main-slider'),_c('hr'),_c('features'),_c('hr'),_c('banners'),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }